<!-- HERO -->
<section class="relative h-screen">
    <!-- <img class="absolute inset-0 w-full h-full object-cover" src="assets/img/slider.png" /> -->
    <video class="hidden sm:block absolute inset-0 w-full h-full object-cover" autoplay
  muted
  loop
  playsinline
  webkit-playsinline
  preload="metadata"
  disablepictureinpicture
  controlslist="nodownload nofullscreen noremoteplayback" *ngIf="!isMobile()" src="assets/img/bg_01.mp4"></video>
    <img src="assets/img/bg_mob.png" *ngIf="isMobile()" class="block sm:hidden absolute inset-0 w-full h-full object-cover" alt="bg mobile">
    <div class="absolute inset-0 bg-black/60"></div>
    <div class="relative h-full flex flex-col items-center justify-center text-center text-white px-6">
        <div class=" flex flex-col text-6xl md:text-8xl font-light leading-tight font-baskerville-italic text-white">
            <h1 class="font-baskerville-italic ">Luxury isn’t showcased</h1>
            <h1 class=" font-baskerville-italic ">It’s 
                <div class="word-rotator">
                    <span>Curated</span>
                    <span>Selected</span>
                    <span>Tailored</span>
                    <span>Exclusive</span>
                </div>
            </h1>
        </div>
        <div class="bg-[#ffffff]/20 mt-10 rounded-2xl py-4 px-8 shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[5px] border border-[#ffffff]/30">
            <p class="body-lg text-white/90 max-w-2xl mx-auto ">
                Welcome to Bengaluru’s most exclusive, invite-only portfolio of luxury residences.
            </p>
        </div>
       <div class="mt-14 flex justify-center gap-4">
            <button (click)="navigateWithReload('/search')" class="theme-btn1 font-semibold py-3 px-10 text-white rounded-full">
                <span>Explore &nbsp;</span>
                @if (!isLoggedIn()) {
                    <span>300+ &nbsp;</span> 
                }
                <span>Curated Homes</span>
            </button>
        </div>
    </div>
</section>

<!-- SEARCH -->
<section class="relative md:-mt-24 z-30 mb-10">
    <div class="w-full max-w-[1040px] mx-auto px-4">
        <div class="search-strip rounded-t-2xl px-4 md:px-8 py-6 md:py-12 mt-6 bg-white">
            
            <div class="relative w-full">

                <!-- Search Bar -->
                <div class="search-bar flex flex-col md:flex-row items-stretch md:items-center gap-3 md:gap-4 rounded-2xl md:rounded-full px-2 py-2 md:bg-white md:border md:border-gray-100">
              
                  <input
                    type="text"
                    placeholder="Search Properties..."
                    class="flex-1 outline-none text-base md:text-sm text-gray-700 px-4 py-3 md:py-2 bg-gray-50 md:bg-transparent rounded-full md:rounded-none"
                    name="search"
                    [(ngModel)]="searchItem"
                    (ngModelChange)="onSearchChange($event)"
                    (keyup.enter)="searchProp()"
                    autocomplete="off" />
              
                  <button
                    class="bg-black text-white px-8 py-3 md:py-2 rounded-full text-sm font-bold transition-transform active:scale-95 shadow-lg md:shadow-none"
                    (click)="searchProp()">
                    Search
                  </button>
              
                </div>
              
                <!-- Dropdown Results -->
                @if (showDropdown) {
                  <div class="absolute z-50 left-0 right-0 mt-2 bg-white border border-gray-100 rounded-2xl shadow-xl overflow-hidden">
              
                    <!-- Loading -->
                    @if (isSearching) {
                      <div class="flex items-center justify-center gap-2 py-6 text-gray-400 text-sm">
                        <svg class="animate-spin w-4 h-4" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"/>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"/>
                        </svg>
                        Searching...
                      </div>
                    }
              
                    <!-- Results List -->
                    @else if (searchResults.length > 0) {
                      <ul class="divide-y divide-gray-50 max-h-80 overflow-y-auto">
                        @for (prop of searchResults; track prop._id) {
                          <li
                            class="flex items-center gap-4 px-5 py-3 hover:bg-gray-50 cursor-pointer transition-colors"
                            (click)="selectProperty(prop)">
              
                            <!-- Thumbnail -->
                            <div class="w-12 h-12 rounded-xl overflow-hidden bg-gray-100 flex-shrink-0">
                              @if (prop.galleryImage?.[0]) {
                                <img [src]="prop.galleryImage[0]" [alt]="prop.name" class="w-full h-full object-cover" />
                              } @else {
                                <div class="w-full h-full flex items-center justify-center text-gray-300">
                                  <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                                      d="M3 9.75L12 3l9 6.75V21a.75.75 0 01-.75.75H3.75A.75.75 0 013 21V9.75z"/>
                                  </svg>
                                </div>
                              }
                            </div>
              
                            <!-- Info -->
                            <div class="flex-1 min-w-0">
                              <p class="text-sm font-semibold text-gray-800 truncate">{{ prop.name }}</p>
                              <p class="text-xs text-gray-400 truncate">{{ prop.microMarket.micromarketName }}</p>
                            </div>
              
                            <!-- Price -->
                            <div class="text-right flex-shrink-0">
                                @if (prop.price?.length > 0) {
                              
                                  <!-- Min - Max Price Range -->
                                  <p class="text-sm font-bold text-black">
                                    {{ getMinPrice(prop.price)}}
                                    @if (prop.price.length > 1) {
                                      <span class="font-normal text-gray-400 mx-0.5">–</span>
                                      {{ getMaxPrice(prop.price)}}
                                    }
                                  </p>
                              
                                  <!-- BHK Types -->
                                  <p class="text-xs text-gray-400">
                                    {{ getBhkTypes(prop.price) }}
                                  </p>
                              
                                } @else {
                                  <p class="text-sm font-bold text-black">Price on Request</p>
                                  <p class="text-xs text-gray-400">{{ prop.type }}</p>
                                }
                              </div>
              
                          </li>
                        }
                      </ul>
              
                      <!-- View All Results -->
                      <div
                        class="px-5 py-3 bg-gray-50 border-t border-gray-100 text-center cursor-pointer hover:bg-gray-100 transition-colors"
                        (click)="searchProp()">
                        <p class="text-xs font-semibold text-black">
                          View all results for "<span class="text-blue-600">{{ searchItem }}</span>"
                        </p>
                      </div>
                    }
              
                    <!-- No Data Found -->
                    @else {
                      <div class="flex flex-col items-center justify-center py-10 gap-2 text-gray-400">
                        <svg class="w-10 h-10 text-gray-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                            d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"/>
                        </svg>
                        <p class="text-sm font-medium">No properties found</p>
                        <p class="text-xs">Try a different name or location</p>
                      </div>
                    }
              
                  </div>
                }
              
              </div>
        </div>
    </div> 
</section>

<app-slider></app-slider>

<section class="w-full py-16">
  <!-- TRUST LOGO MARQUEE -->
  <div class="max-w-[1440px] mx-auto px-6">
    <div class="text-center max-w-4xl mx-auto">

      <p class="text-xs uppercase tracking-[3px] font-semibold text-[#8C52FF]">

        TRUSTED BY GLOBAL PROFESSIONALS

      </p>

      <h2 class="mt-4 text-4xl md:text-5xl leading-tight text-black">

        Helping leaders of leading companies
        find their Bengaluru home

      </h2>

      <p class="mt-6 text-lg text-[#595959]">

        From founders and CXOs to technology leaders and global professionals,
        we help families make confident real estate decisions in Bengaluru.

      </p>

    </div>
    <div class="mt-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6">

      @for (logo of logos; track logo) {

        <div
          class="h-[110px]
                 bg-white
                 border border-gray-100
                 rounded-3xl
                 flex items-center justify-center
                 hover:shadow-lg
                 transition-all p-2 duration-300">

          <img
            [src]="logo"
            class="max-h-10 w-auto opacity-70 hover:opacity-100 transition">

        </div>

      }

    </div>
    <!-- <div class="marquee flex items-center gap-12">

        <img src="assets/img/logos/ub.png" class="logo" />
        <img src="assets/img/logos/lightspeed.png" class="logo" />
        <img src="assets/img/logos/ola.png" class="logo" />
        <img src="assets/img/logos/bb.png" class="logo" />
        <img src="assets/img/logos/linde.png" class="logo" />
        <img src="assets/img/logos/infosys.png" class="logo" />
        <img src="assets/img/logos/nvidia.png" class="logo" />
        <img src="assets/img/logos/wipro.png" class="logo" />
        <img src="assets/img/logos/peak.png" class="logo" />
        <img src="assets/img/logos/techni.png" class="logo" />
        <img src="assets/img/logos/jsa.png" class="logo" />
        <img src="assets/img/logos/ujjivan.png" class="logo" />
        <img src="assets/img/logos/itc.png" class="logo" />
        <img src="assets/img/logos/tally.png" class="logo" />
        <img src="assets/img/logos/bcg.png" class="logo" />
        <img src="assets/img/logos/360.png" class="logo" />
        <img src="assets/img/logos/kearney.png" class="logo" />

        <img src="assets/img/logos/ub.png" class="logo" />
        <img src="assets/img/logos/lightspeed.png" class="logo" />
        <img src="assets/img/logos/ola.png" class="logo" />
        <img src="assets/img/logos/bb.png" class="logo" />
        <img src="assets/img/logos/linde.png" class="logo" />
        <img src="assets/img/logos/infosys.png" class="logo" />
        <img src="assets/img/logos/nvidia.png" class="logo" />
        <img src="assets/img/logos/wipro.png" class="logo" />
        <img src="assets/img/logos/peak.png" class="logo" />
        <img src="assets/img/logos/techni.png" class="logo" />
        <img src="assets/img/logos/jsa.png" class="logo" />
        <img src="assets/img/logos/ujjivan.png" class="logo" />
        <img src="assets/img/logos/itc.png" class="logo" />
        <img src="assets/img/logos/tally.png" class="logo" />
        <img src="assets/img/logos/bcg.png" class="logo" />
        <img src="assets/img/logos/360.png" class="logo" />
        <img src="assets/img/logos/kearney.png" class="logo" />

    </div> -->
  </div> 
</section> 

<!-- Why choose us start -->
<section class="w-full py-28 bg-gradient-to-b from-white-50 to-purple-200">
    <div class="flex gap-4 justify-center w-full mb-12">
        <svg fill="none" class="h-[12px] w-[12px]" viewBox="0 0 11 11"><path d="M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="#8C52FF"></path></svg>
        <svg fill="none" class="h-[12px] w-[12px]" viewBox="0 0 11 11"><path d="M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="#8C52FF"></path></svg>
        <svg fill="none" class="h-[12px] w-[12px]" viewBox="0 0 11 11"><path d="M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z" fill="#8C52FF"></path></svg>
    </div>
    <div class="max-w-[1440px] mx-auto px-6">

        <!-- Heading -->
        <div class="text-center mb-20">
          <h2 class="text-3xl sm:text-4xl text-gray-900 max-w-4xl mx-auto">
              A more thoughtful way to discover and access exceptional homes.
          </h2>
        </div>

        <!-- Cards -->
        <div class="grid grid-cols-1 md:grid-cols-3 gap-8">

        <!-- Card 1 -->
        <div class="flex flex-col justify-between relative backdrop-blur-lg rounded-[20px] p-8 
            border border-1.5 border-white bg-gradient-to-b from-purple to-gray
            shadow-[0_10px_30px_rgba(0,0,0,0.1)] 
            transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.1)] hover:-translate-y-1">

            <div>
                <p class="label text-gray-500 mb-2">
                    PRIVATE NETWORK
                </p>

                <h3 class="text-lg font-semibold text-gray-900 mb-3">
                    Private network of homes
                </h3>

                <p class="text-gray-600 leading-relaxed mb-8">
                    Circled Plus gives you access to a curated pool of high-quality residences 
                    across Bengaluru, including listings that never make it to public portals.
                </p>
            </div>

            <!-- Image Strip -->
            <div class="h-20 rounded-full overflow-hidden relative">
            <div class="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent z-10"></div>
            <img src="assets/img/slider.png" class="w-full h-full object-cover" />
            </div>
        </div>

        <!-- Card 2 -->
        <div class="flex flex-col justify-between relative backdrop-blur-lg rounded-[20px] p-8 
            border border-1.5 border-white bg-gradient-to-b from-purple to-gray
            shadow-[0_10px_30px_rgba(0,0,0,0.1)] 
            transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.1)] hover:-translate-y-1">

            <div>
                <p class="label text-gray-500 mb-2">
                    CURATED SELECTION
                </p>

                <h3 class="text-lg font-semibold text-gray-900 mb-3">
                    Curated, not crowded
                </h3>

                <p class="text-gray-600 leading-relaxed mb-8">
                    Every property is handpicked. We focus on relevance, quality, 
                    and liveability — not volume.
                </p>
            </div>

            <!-- Image Strip -->
            <div class="h-20 rounded-full overflow-hidden relative">
            <div class="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent z-10"></div>
            <img src="assets/img/category1.png" class="w-full h-full object-cover" />
            </div>
        </div>

        <!-- Card 3 -->
        <div class="flex flex-col justify-between relative backdrop-blur-lg rounded-[20px] p-8 
            border border-1.5 border-white bg-gradient-to-b from-purple to-gray
            shadow-[0_10px_30px_rgba(0,0,0,0.1)] 
            transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.1)] hover:-translate-y-1">

            <div>
                <p class="label text-gray-500 mb-2">
                    CONFIDENTIALITY
                </p>

                <h3 class="text-lg font-semibold text-gray-900 mb-3">
                    Private & discreet
                </h3>

                <p class="text-gray-600 leading-relaxed mb-8">
                    Your details stay confidential. We don’t share your information across 
                    broker networks or expose you to unnecessary calls.
                </p>
            </div>

            <!-- Image Strip -->
            <div class="h-20 rounded-full overflow-hidden relative">
            <div class="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent z-10"></div>
            <img src="assets/img/pxl.jpg" class="w-full h-full object-cover" />
            </div>
        </div>

        </div>

    </div>
</section>
<!-- Why choose us End -->

<!-- what you get -->
<section class="parallax-section relative w-full py-28 overflow-hidden text-white">

  <!-- PARALLAX BACKGROUND -->
  <div class="absolute inset-0 -z-20 overflow-hidden">
    <img 
      src="https://images.pexels.com/photos/4497542/pexels-photo-4497542.jpeg"
      class="w-full h-full object-cover scale-110 parallax-img"
    />
  </div>

  <!-- DARK OVERLAY (important for readability) -->
  <div class="absolute inset-0 -z-10 bg-gradient-to-b from-[#0F1115]/90 via-[#0F1115]/70 to-[#0F1115]/90"></div>

  <!-- SOFT RADIAL GLOW -->
  <div class="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_20%_20%,rgba(255,255,255,0.05),transparent)]"></div>

  <div class="max-w-[1440px] mx-auto px-6">

    <div class="grid grid-cols-1 md:grid-cols-2 gap-16">

      <!-- LEFT -->
      <div>
        <h2 class="text-3xl sm:text-4xl font-semibold leading-tight">
          What you get with Circled Plus?
        </h2>

        <p class="text-gray-400 mt-6 max-w-md leading-relaxed">
          A more thoughtful and curated way to discover, evaluate, and access 
          high-quality homes — without the noise.
        </p>
      </div>

      <!-- RIGHT -->
      <div class="flex flex-col divide-y divide-white/10">

        <!-- Item -->
        <div class="py-6 flex gap-4 group transition-all duration-300 hover:translate-x-2">
          
          <!-- Icon -->
          <div class="w-10 h-10 flex items-center justify-center rounded-full 
                      bg-white/5 border border-white/10 
                      group-hover:bg-white/10 transition shadow-[0_0_20px_rgba(255,255,255,0.05)]">
            <i class="fa fa-lock text-sm text-gray-300"></i>
          </div>

          <div>
            <h3 class="text-lg font-semibold mb-1">
              Access to private inventory
            </h3>
            <p class="text-gray-400 leading-relaxed">
              Explore homes that are not available on public platforms, including off-market opportunities.
            </p>
          </div>
        </div>

        <!-- Item -->
        <div class="py-6 flex gap-4 group transition-all duration-300 hover:translate-x-2">
          <div class="w-10 h-10 flex items-center justify-center rounded-full 
                      bg-white/5 border border-white/10 
                      group-hover:bg-white/10 transition shadow-[0_0_20px_rgba(255,255,255,0.05)]">
            <i class="fa fa-filter text-sm text-gray-300"></i>
          </div>

          <div>
            <h3 class="text-lg font-semibold mb-1">
              Curated shortlists
            </h3>
            <p class="text-gray-400 leading-relaxed">
              Receive only relevant options based on your requirements — not endless listings.
            </p>
          </div>
        </div>

        <!-- Item -->
        <div class="py-6 flex gap-4 group transition-all duration-300 hover:translate-x-2">
          <div class="w-10 h-10 flex items-center justify-center rounded-full 
                      bg-white/5 border border-white/10 
                      group-hover:bg-white/10 transition shadow-[0_0_20px_rgba(255,255,255,0.05)]">
            <i class="fa fa-bolt text-sm text-gray-300"></i>
          </div>

          <div>
            <h3 class="text-lg font-semibold mb-1">
              Timely discovery
            </h3>
            <p class="text-gray-400 leading-relaxed">
              Be among the first to know when the right property becomes available.
            </p>
          </div>
        </div>

        <!-- Item -->
        <div class="py-6 flex gap-4 group transition-all duration-300 hover:translate-x-2">
          <div class="w-10 h-10 flex items-center justify-center rounded-full 
                      bg-white/5 border border-white/10 
                      group-hover:bg-white/10 transition shadow-[0_0_20px_rgba(255,255,255,0.05)]">
            <i class="fa fa-user text-sm text-gray-300"></i>
          </div>

          <div>
            <h3 class="text-lg font-semibold mb-1">
              Advisory when it matters
            </h3>
            <p class="text-gray-400 leading-relaxed">
              Engage with a dedicated advisor when you’re ready — without unnecessary follow-ups.
            </p>
          </div>
        </div>

      </div>

    </div>

  </div>
</section>
<!-- what you get end -->

<!-- Help With Us  Start -->
<section class="w-full py-28 bg-gradient-to-t from-white-50 to-purple-100">
  <div class="max-w-[1200px] mx-auto px-6">

    <!-- Heading -->
    <div class="mb-16">
      <h2 class="text-3xl sm:text-4xl font-semibold text-gray-900">
        We can help you discover better, faster.
      </h2>
      <p class="text-gray-600 mt-6 max-w-xl">
        From intelligent matching to private access, every part of the experience 
        is designed to reduce noise and bring clarity to your search.
      </p>
    </div>

    <!-- Feature List -->
    <div class="flex flex-col gap-6">

      <!-- Item -->
      <div class="flex flex-col md:flex-row justify-between relative backdrop-blur-lg rounded-[20px] p-8 
        border border-1.5 border-white bg-gradient-to-b from-purple to-gray
        shadow-[0_10px_30px_rgba(0,0,0,0.1)] 
        transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.1)] hover:-translate-y-1">

        <!-- TEXT -->
        <div class="relative z-10 max-w-xl">
          <h3 class="text-xl font-semibold text-gray-900 mb-2">
            Smart recommendations
          </h3>
          <p class="text-gray-600 leading-relaxed">
            AI property-matching technology reduces the time and effort involved in finding a suitable home.
          </p>
        </div>

        <!-- BACKGROUND IMAGE -->
         <div class="w-[300px] h-[80px] mt-6 sm:mt-0 rounded-full overflow-hidden shrink-0">
          <img src="assets/img/slider.png"
               class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>

      </div>

      <!-- Item -->
      <div class="flex flex-col md:flex-row justify-between relative backdrop-blur-lg rounded-[20px] p-8 
        border border-1.5 border-white bg-gradient-to-b from-purple to-gray
        shadow-[0_10px_30px_rgba(0,0,0,0.1)] 
        transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.1)] hover:-translate-y-1">

        <div class="relative z-10 max-w-xl">
          <h3 class="text-xl font-semibold text-gray-900 mb-2">
            Private access
          </h3>
          <p class="text-gray-600 leading-relaxed">
            Many of our listings are marketed privately and not on public portals, letting you explore discreetly and schedule tours at your convenience.
          </p>
        </div>

        <!-- BACKGROUND IMAGE -->
         <div class="w-[300px] h-[80px] mt-6 sm:mt-0 rounded-full overflow-hidden shrink-0">
          <img src="assets/img/gallery4.png"
               class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>

      </div>

      <!-- Item -->
      <div class="flex flex-col md:flex-row justify-between relative backdrop-blur-lg rounded-[20px] p-8 
        border border-1.5 border-white bg-gradient-to-b from-purple to-gray
        shadow-[0_10px_30px_rgba(0,0,0,0.1)] 
        transition-all duration-500 hover:shadow-[0_20px_60px_rgba(0,0,0,0.1)] hover:-translate-y-1">

        <div class="relative z-10 max-w-xl">
          <h3 class="text-xl font-semibold text-gray-900 mb-2">
            Targeted alerts
          </h3>
          <p class="text-gray-600 leading-relaxed">
            You’ll receive personalized updates when new homes that fit your criteria become available.
          </p>
        </div>

        <!-- BACKGROUND IMAGE -->
         <div class="w-[300px] h-[80px] mt-6 sm:mt-0 rounded-full overflow-hidden shrink-0">
          <img src="assets/img/gallery5.png"
               class="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        </div>

      </div>

    </div>

  </div>
</section>
<!-- with Help Us End -->

<!-- Why Listing start -->
<section class="w-full py-32 bg-[#0B1220] text-white">
    <div class="max-w-[1300px] mx-auto px-6 text-center">

      <!-- Heading -->
      <h2 class="text-3xl sm:text-4xl font-semibold mb-6">
        Why private listings..?
      </h2>

      <p class="text-gray-400 max-w-2xl mx-auto mb-16">
        A more thoughtful way to discover, evaluate, and access high-quality <br> homes — without the noise.
      </p>

      <!-- Cards -->
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8">

        <!-- Card 1 -->
        <div class="group relative p-10 rounded-2xl 
                    border border-white/15 
                    bg-gradient-to-b from-white/10 to-white/5 
                    backdrop-blur-xl 
                    shadow-[0_10px_40px_rgba(0,0,0,0.4)] 
                    transition-all duration-500 
                    hover:from-white/15 hover:to-white/10 
                    hover:-translate-y-1 hover:shadow-[0_0_60px_rgba(168,85,247,0.15)]">

          <!-- Glass highlight -->
          <div class="absolute inset-0 rounded-2xl 
                      bg-gradient-to-br from-white/10 via-transparent to-transparent 
                      opacity-60 pointer-events-none"></div>

          <!-- Icon -->
          <div class="relative mb-8 mx-auto flex items-center justify-center">

              <!-- Inner -->
              <div class="w-14 h-14 flex items-center justify-center 
                          rounded-full 
                          bg-white/10 backdrop-blur-md 
                          border border-white/20 
                          shadow-[inset_0_1px_1px_rgba(255,255,255,0.2)]">

                <img src="assets/img/pvtl-1.svg" 
                    class="w-10 h-10 opacity-90" />

              </div>

          </div>

          <!-- Content -->
          <h3 class="text-xl font-semibold mb-3 text-purple-400">
            Discretion & control
          </h3>

          <p class="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto">
            Off-market listings give sellers privacy and reduce public scrutiny, while allowing them to control who sees their home.
          </p>

        </div>

        <!-- Card 2 -->
        <div class="group relative p-10 rounded-2xl 
                    border border-white/15 
                    bg-gradient-to-b from-white/10 to-white/5 
                    backdrop-blur-xl 
                    shadow-[0_10px_40px_rgba(0,0,0,0.4)] 
                    transition-all duration-500 
                    hover:from-white/15 hover:to-white/10 
                    hover:-translate-y-1 hover:shadow-[0_0_60px_rgba(168,85,247,0.15)]">

          <div class="absolute inset-0 rounded-2xl 
                      bg-gradient-to-br from-white/10 via-transparent to-transparent 
                      opacity-60 pointer-events-none"></div>

          <div class="relative mb-8 mx-auto flex items-center justify-center">

              <div class="w-14 h-14 flex items-center justify-center 
                          rounded-full 
                          bg-white/10 backdrop-blur-md 
                          border border-white/20 
                          shadow-[inset_0_1px_1px_rgba(255,255,255,0.2)]">

                <img src="assets/img/pvtl-2.svg" 
                    class="w-10 h-10 opacity-90" />

              </div>

          </div>

          <h3 class="text-xl font-semibold mb-3 text-purple-400">
            Reduced competition
          </h3>

          <p class="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto">
            You engage with a sales advisor only when you're ready, ensuring a high-touch experience tailored to you.
          </p>

        </div>

        <!-- Card 3 -->
        <div class="group relative p-10 rounded-2xl 
                    border border-white/15 
                    bg-gradient-to-b from-white/10 to-white/5 
                    backdrop-blur-xl 
                    shadow-[0_10px_40px_rgba(0,0,0,0.4)] 
                    transition-all duration-500 
                    hover:from-white/15 hover:to-white/10 
                    hover:-translate-y-1 hover:shadow-[0_0_60px_rgba(168,85,247,0.15)]">

          <div class="absolute inset-0 rounded-2xl 
                      bg-gradient-to-br from-white/10 via-transparent to-transparent 
                      opacity-60 pointer-events-none"></div>

          <div class="relative mb-8 mx-auto flex items-center justify-center">

              <div class="w-14 h-14 flex items-center justify-center 
                          rounded-full 
                          bg-white/10 backdrop-blur-md 
                          border border-white/20 
                          shadow-[inset_0_1px_1px_rgba(255,255,255,0.2)]">

                <img src="assets/img/pvtl-3.svg" 
                    class="w-10 h-10 opacity-90" />

              </div>

          </div>

          <h3 class="text-xl font-semibold mb-3 text-purple-400">
            Quality over quantity
          </h3>

          <p class="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto">
            Private listing networks focus on high-quality homes, ensuring every property is exceptional.
          </p>

        </div>

      </div>

    </div>
</section>
<!-- Why Listing start -->

<!-- Advisor start -->
<section class="w-full py-20 bg-[#F9FAFB]">
  <div class="max-w-[1300px] mx-auto px-6">

    <!-- Heading -->
    <div class="text-center mb-16">
      <h2 class="text-3xl sm:text-4xl font-semibold text-gray-900 mb-4">
        Connect with our advisors
      </h2>
      <p class="text-gray-500 max-w-2xl mx-auto">
        Work with experienced advisors who understand your requirements and guide you with clarity and discretion.
      </p>
    </div>

    <!-- Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-8">

      <!-- Card -->
      <div class="group relative p-8 rounded-2xl relative flex flex-col justify-between h-full 
                  bg-white/70 backdrop-blur-xl 
                  border border-gray-200 
                  shadow-[0_10px_40px_rgba(0,0,0,0.06)]
                  transition-all duration-500 
                  hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">

        <!-- Content -->
        <p class="text-gray-700 leading-relaxed mb-8 text-sm">
          Suchit brings 14+ years of experience across real estate advisory and home loan expertise, with deep experience in helping clients navigate high-value property decisions. Known for his sharp market understanding and client-first approach, he’s committed to guiding every client with clarity, trust, and results-focused advice.
        </p>

        <!-- Profile -->
        <div class="flex items-center justify-between mt-auto">

          <!-- Name -->
          <div>
            <h3 class="text-lg font-semibold text-gray-900">
              Suchit Nair
            </h3>
            <p class="text-sm text-gray-400">
              Senior Advisor
            </p>
          </div>

          <!-- Image -->
            <div class="relative w-24 h-24 rounded-xl overflow-hidden bg-gray-100 flex items-end justify-center">
    
                <img src="assets/img/suchit.png" 
                    class="h-[90%] object-contain object-bottom scale-110" />

                <div class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white/60 to-transparent"></div>
            </div>

        </div>

      </div>

      <!-- Card -->
      <div class="group relative p-8 rounded-2xl relative flex flex-col justify-between h-full 
                  bg-white/70 backdrop-blur-xl 
                  border border-gray-200 
                  shadow-[0_10px_40px_rgba(0,0,0,0.06)]
                  transition-all duration-500 
                  hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">

        <p class="text-gray-700 leading-relaxed mb-8 text-sm">
          Explore homes with guidance tailored to your requirements. Our advisors help bring structure and clarity to your property search.
        </p>

        <div class="flex items-center justify-between mt-auto">

          <div>
            <h3 class="text-lg font-semibold text-gray-900">
              Komal R
            </h3>
            <p class="text-sm text-gray-400">
              Advisor
            </p>
          </div>

          <!-- Image -->
            <div class="relative w-24 h-24 rounded-xl overflow-hidden bg-gray-100 flex items-end justify-center">
    
                <img src="assets/img/komal-r.png" alt="Komal R"
                    class="h-[90%] object-contain object-bottom scale-110" />

                <div class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white/60 to-transparent"></div>
            </div>

        </div>

      </div>

      <!-- Card -->
      <div class="group relative p-8 rounded-2xl relative flex flex-col justify-between h-full 
                  bg-white/70 backdrop-blur-xl 
                  border border-gray-200 
                  shadow-[0_10px_40px_rgba(0,0,0,0.06)]
                  transition-all duration-500 items-between 
                  hover:-translate-y-2 hover:shadow-[0_20px_60px_rgba(0,0,0,0.12)]">

        <p class="text-gray-700 leading-relaxed mb-8 text-sm">
          Kevin’s 14-year career across aviation, procurement, and travel operations gives him a uniquely disciplined, solutions-first approach. Clients value his dependability, discretion, and commitment to getting things done.
        </p>

        <div class="flex items-center justify-between mt-auto">

          <div>
            <h3 class="text-lg font-semibold text-gray-900">
              Kevin Irudiaraj
            </h3>
            <p class="text-sm text-gray-400">
              Senior Advisor
            </p>
          </div>

          <!-- Image -->
            <div class="relative w-24 h-24 rounded-xl overflow-hidden bg-gray-100 flex items-end justify-center">
    
                <img src="assets/img/kevin.png" 
                    class="h-[90%] object-contain object-bottom scale-110" />

                <div class="absolute bottom-0 w-full h-6 bg-gradient-to-t from-white/60 to-transparent"></div>
            </div>

        </div>

      </div>

    </div>

  </div>
</section>
<!-- Advisor End -->

<!-- Collection Start -->
<section class="w-full py-16 bg-white">
  <div class="max-w-[1300px] mx-auto px-6">

    <!-- Heading -->
    <h2 class="text-3xl sm:text-4xl text-center font-semibold text-gray-900 mb-16">
      Property collection
    </h2>

    <!-- Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">

      <!-- LEFT HERO -->
      <div class="lg:col-span-2 relative rounded-3xl overflow-hidden group h-[420px]">

        <img src="assets/img/category1.png"
             class="w-full h-full object-cover group-hover:scale-105 transition duration-700" />

        <!-- Overlay -->
        <div class="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

        <div class="absolute bottom-10 left-10 text-white max-w-md">
          <p class="text-sm opacity-80 mb-2">Categories</p>
          <h3 class="text-2xl md:text-4xl font-semibold leading-tight">
            Creating Connections Between You And Your Dream Home
          </h3>
        </div>
      </div>

      <!-- RIGHT STACK -->
      <div class="flex flex-col gap-6">

        <!-- Villas -->
        <div class="relative rounded-3xl overflow-hidden group h-[200px]">

          <img src="https://images.pexels.com/photos/17174767/pexels-photo-17174767.jpeg"
               class="w-full h-full object-cover object-center group-hover:scale-105 transition duration-700" />

          <div class="absolute inset-0 bg-black/50"></div>

          <div class="absolute inset-0 p-6 flex flex-col justify-between text-white">
            <div>
              <p class="text-sm opacity-80">Villas</p>
              <h3 class="text-xl font-semibold">
                Exclusive Luxury Villas
              </h3>
            </div>

            <button class="w-10 h-10 bg-white text-black rounded-full flex items-center justify-center"
                    (click)="gotoSearch('Villa')">
              <i class="fa-solid fa-arrow-up rotate-45"></i>
            </button>
          </div>
        </div>

        <!-- Apartments -->
        <div class="relative rounded-3xl overflow-hidden group h-[200px]">

          <img src="https://images.pexels.com/photos/25565759/pexels-photo-25565759.png"
               class="w-full h-full object-cover object-center group-hover:scale-105 transition duration-700" />

          <div class="absolute inset-0 bg-black/50"></div>

          <div class="absolute inset-0 p-6 flex flex-col justify-between text-white">
            <div>
              <p class="text-sm opacity-80">Apartments</p>
              <h3 class="text-xl font-semibold">
                Luxury Apartments
              </h3>
            </div>

            <button class="w-10 h-10 bg-white text-black rounded-full flex items-center justify-center"
                    (click)="gotoSearch('Apartment')">
              <i class="fa-solid fa-arrow-up rotate-45"></i>
            </button>
          </div>
        </div>

      </div>

      <!-- Lands -->
      <div class="relative rounded-3xl overflow-hidden group h-[220px]">

        <img src="https://images.pexels.com/photos/9203789/pexels-photo-9203789.jpeg"
             class="w-full h-full object-cover object-center group-hover:scale-105 transition duration-700" />

        <div class="absolute inset-0 bg-black/50"></div>

        <div class="absolute inset-0 p-6 flex flex-col justify-between text-white">
          <div>
            <p class="text-sm opacity-80">Lands</p>
            <h3 class="text-xl font-semibold">
              Residential & Investment Lands
            </h3>
          </div>

          <button class="w-10 h-10 bg-white text-black rounded-full flex items-center justify-center"
                  (click)="gotoSearch('Lands')">
            <i class="fa-solid fa-arrow-up rotate-45"></i>
          </button>
        </div>
      </div>

      <!-- Commercial -->
      <div class="relative rounded-3xl overflow-hidden group h-[220px]">

        <img src="https://images.pexels.com/photos/33803366/pexels-photo-33803366.jpeg"
             class="w-full h-full object-cover object-center opacity-90" />

        <div class="absolute inset-0 bg-black/60"></div>

        <div class="absolute inset-0 p-6 flex flex-col justify-between text-white">
          <div>
            <p class="text-sm opacity-80">Commercial</p>
            <h3 class="text-xl font-semibold">
              Prime Commercial Space
            </h3>
          </div>

          <p class="text-purple-400 text-sm font-medium">
            Coming Soon
          </p>
        </div>
      </div>

    </div>

  </div>
</section>
<!-- Collection End -->

<!-- Plan Start -->
<section class="w-full py-28 bg-gradient-to-b from-white to-purple-50" id="plans">
  <div class="max-w-[1200px] mx-auto px-6 text-center">

    <!-- Heading -->
    <h2 class="text-3xl sm:text-4xl font-semibold text-gray-900 mb-16">
      Our Plans
    </h2>

    <!-- Cards -->
    <div class="grid md:grid-cols-2 gap-10 relative">

      <!-- Soft Glow Background -->
      <div class="absolute inset-0 flex justify-center items-center -z-10">
        <div class="w-[500px] h-[400px] bg-purple-400/20 blur-[120px] rounded-full"></div>
      </div>

      <!-- STARTER -->
      <div class="bg-white/80 backdrop-blur-md rounded-3xl p-10 shadow-[0_20px_60px_rgba(0,0,0,0.08)]
                  border border-gray-100 text-left transition hover:shadow-[0_30px_80px_rgba(0,0,0,0.12)]">

        <h3 class="text-2xl font-semibold text-gray-900">Starter</h3>
        <p class="text-gray-500 mt-1">Basic plan for every user</p>

        <h4 class="text-4xl font-semibold mt-8">Free</h4>

        <ul class="mt-8 space-y-4 text-gray-700">
          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Experience upto 3 property listing</span>
          </li>
          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Access unlimited hand-picked shortlists from our advisors</span>
          </li>
        </ul>

        <button routerLink="/login" class="mt-10 w-full cursor-pointer py-3 rounded-xl border border-gray-300 text-gray-700 font-medium 
                       hover:bg-gray-50 transition">
          Get started
        </button>
      </div>

      <!-- PREMIUM (FOCUS CARD) -->
      <div class="relative bg-white rounded-3xl p-10 shadow-[0_25px_80px_rgba(124,58,237,0.25)]
                  border border-purple-200 text-left scale-[1.02]">

        <!-- Glow -->
        <div class="absolute inset-0 rounded-3xl bg-gradient-to-br from-purple-500/10 to-transparent pointer-events-none"></div>

        <!-- Badge -->
        <div class="absolute -top-5 left-1/2 -translate-x-1/2 
                    bg-black text-white text-sm px-5 py-1.5 rounded-full shadow">
          Recommended
        </div>

        <h3 class="text-2xl font-semibold text-gray-900">Premium</h3>
        <p class="text-gray-500 mt-1">Exclusive member benefits</p>

        <h4 class="text-4xl font-semibold mt-8">
          ₹3,000
          <span class="text-base text-gray-500 font-normal">/ 3 months</span>
        </h4>

        <ul class="mt-8 space-y-4 text-gray-700">
          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Unlimited property listing</span>
          </li>

          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Priority access to new & Private listings</span>
          </li>

          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Personalised property alerts</span>
          </li>

          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Curated property shortlists</span>
          </li>

          <li class="flex items-start gap-3">
            <span class="w-6 h-6 rounded-full bg-purple-100 text-purple-600 flex items-center justify-center text-xs">✓</span>
            <span>Dedicated relationship advisors</span>
          </li>
        </ul>

        <p class="text-xs text-gray-500 mt-6">
          *Terms & Conditions Applied
        </p>

        @if (!isLoggedIn) {
          <button routerLink="/login"
            class="mt-10 w-full py-4 rounded-full text-white font-semibold
                   theme-btn1 
                   shadow-lg hover:shadow-xl transition">
            Choose Plan
          </button>
        }
        @else {
          <button routerLink="/payment"
            class="mt-10 w-full py-4 rounded-full text-white font-semibold
                   theme-btn1 
                   shadow-lg hover:shadow-xl transition">
            Choose Plan
          </button>
        }

      </div>

    </div>

  </div>
</section>
<!-- Plan End -->

<!-- Newsletter Start -->
<section class="w-full py-12 md:py-20">
  <div class="max-w-[1200px] mx-auto px-4 md:px-6">

    <div class="relative rounded-2xl md:rounded-3xl overflow-hidden 
                bg-gradient-to-br from-[#F3EDFF] to-white 
                p-6 md:p-12 shadow-[0_20px_60px_rgba(124,58,237,0.1)]">

      <!-- Glow -->
      <div class="absolute top-0 left-1/2 -translate-x-1/2 
                  w-[300px] md:w-[500px] h-[200px] md:h-[300px] 
                  bg-purple-400/20 blur-[100px] pointer-events-none"></div>

      <div class="relative grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">

        <!-- LEFT -->
        <div>
          <h2 class="text-3xl sm:text-4xl leading-tight font-semibold text-gray-900">
            <span class="text-purple-600">Subscribe</span> to our <br class="hidden md:block"/>
            newsletter
          </h2>

          <p class="mt-4 text-sm md:text-base text-gray-500 max-w-md leading-relaxed">
            Keep up to date with all new properties and exclusive listings.
          </p>
        </div>

        <!-- RIGHT -->
        <div>

          <form (ngSubmit)="subscribe(form)" #form="ngForm" novalidate>

            <!-- Input + Button -->
            <div class="flex flex-col sm:flex-row gap-3 sm:gap-0 
                        bg-white rounded-2xl sm:rounded-full 
                        box-shadow-ff p-2">

              <input 
                type="email"
                name="email_subscribe"
                [(ngModel)]="email_subscribe"
                email
                autocomplete="email"
                #emailField="ngModel"
                required
                placeholder="Enter your email"
                class="flex-1 px-4 md:px-6 py-3 md:py-4 outline-none text-gray-700 bg-transparent"
              />

              <button 
                type="submit"
                [disabled]="form.invalid"
                class="w-full sm:w-auto px-6 py-3 md:py-4 
                       bg-gradient-to-r from-purple-500 to-purple-700 
                       text-white font-medium rounded-xl sm:rounded-full
                       hover:shadow-lg transition disabled:opacity-50">

                Subscribe
              </button>
            </div>

            <!-- Helper Text -->
            <p class="text-xs md:text-sm mt-3 text-gray-400 text-center sm:text-left">
              We respect your privacy. No spam, ever.
            </p>

            <!-- Validation -->
            <p *ngIf="(emailField.touched || form.submitted) && emailField.invalid"
              class="text-red-500 text-xs md:text-sm mt-2">

              <span *ngIf="emailField.errors?.['required']">
                Email is required
              </span>

              <span *ngIf="emailField.errors?.['email']">
                Please enter a valid email address
              </span>
            </p>

            <!-- Success -->
            <p *ngIf="subscribeSuccess" class="text-green-600 mt-3 text-sm">
              Thanks for subscribing to CircledPlus.
            </p>

            <!-- Error -->
            <p *ngIf="subscribeError" class="text-red-500 mt-3 text-sm">
              Something went wrong, please try again later.
            </p>

          </form>

        </div>

      </div>
    </div>

  </div>
</section>
<!-- Newsletter End -->

<!-- bottom HERO SECTION -->
<section class="w-full bg-[#1f1f1f] text-white py-16 relative min-h-screen px-6 lg:px-20 after-sec">
    <div class="max-w-[1440px] mx-auto px-6 py-12">
        <div class="grid grid-cols-1 lg:grid-cols-2 items-center gap-10">

            <!-- LEFT CONTENT -->
            <div>
                <h1 class="text-4xl lg:text-6xl font-bold leading-tight">
                    Redefining Real<br />
                    Estate Through<br />
                    Results
                </h1>

                <div class="mt-8 flex flex-wrap flex-col gap-4" style="max-width: 250px;">
                    <a href="#plans" class="px-6 py-3 rounded-full justify-center text-center theme-btn1 ransition">
                        Get Elite Membership
                    </a>
                    <button (click)="openExpertModal()" 
                        class="px-6 py-3 rounded-full border border-white/60 hover:bg-white hover:text-black transition">
                        Talk to Our Experts
                    </button>
                </div>
            </div>

            <!-- RIGHT CONTENT -->
            <div class="relative flex justify-center">

                <!-- 24/7 -->
                <div class="absolute top-0 right-10 text-center">
                    <p class="text-4xl font-medium">Top 1% </p>
                    <p class="text-sm text-gray-400">Homes in Bengaluru</p>
                </div>

                <!-- DOTTED MAP -->
                <div class="bg-f relative w-[600px] h-[600px] rounded-full  ">

                    <!-- RINGS -->
                    <div class="absolute inset-20 rounded-full border border-white/10"></div>
                    <div class="absolute inset-30 rounded-full border border-white/10"></div>

                    <!-- LOCATION -->
                    <div class="absolute inset-0 flex flex-col items-center justify-center text-sm">
                        <i class="fa-solid fa-2x fa-location-dot text-[yellow]"></i>
                        <p class="mb-0">Bengaluru</p>
                    </div>

                    <!-- STATS -->
                    <div
                        class="absolute top-16 left-8 w-30 h-30 bg-[#342650] blur-4 rounded-full flex flex-col items-center justify-center">
                        <p class="text-2xl font-medium">₹500 Cr+ </p>
                        <p class="text-xs">Curated listing</p>
                    </div>

                    <div
                        class="absolute top-70 right-6 w-32 h-32 bg-[#342650] blur-4 rounded-full flex flex-col items-center justify-center">
                        <p class="text-4xl font-medium">30+</p>
                        <p class="text-xs">Prime Locations</p>
                    </div>

                    <div class="absolute bottom-10 left-10 text-center">
                        <p class="text-4xl font-medium">300+</p>
                        <p class="text-sm text-gray-300">Listings</p>
                    </div>

                </div>

                <!-- TRUST CARD -->
                <div class="absolute -bottom-20 right-0  rounded-xl p-3 flex items-left flex-col gap-3">
                    <img src="assets/img/circle.png" class="w-36 h-12 rounded-lg object-content" />
                    <p class="text-sm text-gray-300   leading-snug">
                        70+ Private Opportunities<br />
                        With invite only access<br />
                    </p>
                </div>

            </div>
        </div>
    </div>
</section>



<!-- Overlay -->
<div *ngIf="isExpertModalOpen"
     class="fixed inset-0 bg-black/50 flex items-center justify-center z-50">

  <!-- Modal card -->
  <div class="bg-white w-full max-w-lg rounded-2xl shadow-2xl p-6 relative">

    <!-- Close -->
    <button (click)="closeExpertModal()"
      class="absolute right-4 top-4 text-gray-400 hover:text-black text-xl">✕</button>

    <!-- FORM VIEW -->
    <div *ngIf="!isFormSubmitted">

      <h2 class="text-2xl font-bold mb-1">Talk to an Expert</h2>
      <p class="text-gray-500 mb-6">We will contact you shortly.</p>

      <form [formGroup]="expertForm" (ngSubmit)="submitExpertForm()" class="space-y-4">

        <!-- Full Name -->
        <div>
          <input
            type="text"
            formControlName="name"
            placeholder="Full Name"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['name'].invalid && f['name'].touched">
          <p *ngIf="f['name'].invalid && f['name'].touched" class="text-red-500 text-xs mt-1">
            Full name is required.
          </p>
        </div>
      
        <!-- Email -->
        <div>
          <input
            type="email"
            formControlName="email"
            placeholder="Email Address"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['email'].invalid && f['email'].touched">
          <p *ngIf="f['email'].errors?.['required'] && f['email'].touched" class="text-red-500 text-xs mt-1">
            Email is required.
          </p>
          <p *ngIf="f['email'].errors?.['email'] && f['email'].touched" class="text-red-500 text-xs mt-1">
            Please enter a valid email address.
          </p>
        </div>
      
        <!-- Mobile -->
        <div>
          <input
            type="tel"
            formControlName="mobile"
            placeholder="Mobile Number"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['mobile'].invalid && f['mobile'].touched">
          <p *ngIf="f['mobile'].errors?.['required'] && f['mobile'].touched" class="text-red-500 text-xs mt-1">
            Mobile number is required.
          </p>
          <p *ngIf="f['mobile'].errors?.['pattern'] && f['mobile'].touched" class="text-red-500 text-xs mt-1">
            Please enter a valid 10-digit mobile number.
          </p>
        </div>
      
        <!-- Message -->
        <div>
          <textarea
            rows="4"
            formControlName="message"
            placeholder="What are you looking for?"
            class="w-full border rounded-lg px-4 py-2 focus:ring-2 focus:ring-blue-500"
            [class.border-red-500]="f['message'].invalid && f['message'].touched">
          </textarea>
          <p *ngIf="f['message'].invalid && f['message'].touched" class="text-red-500 text-xs mt-1">
            Message is required.
          </p>
        </div>
      
        <!-- Submit -->
        <button
          type="submit"
          [disabled]="expertForm.invalid"
          class="w-full bg-[#8B5CF6] text-white py-3 rounded-full font-semibold hover:bg-[#7C3AED] disabled:opacity-50">
          Submit Request
        </button>
      
      </form>
    </div>

    <!-- SUCCESS VIEW -->
    <div *ngIf="isFormSubmitted" class="text-center py-10">
      <div class="text-5xl mb-4">✅</div>
      <h3 class="text-2xl font-bold mb-2">Request Sent!</h3>
      <p class="text-gray-500 mb-6">Our expert will contact you soon.</p>

      <button (click)="closeExpertModal()"
        class="bg-blue-600 text-white px-6 py-2 rounded-full">
        Close
      </button>
    </div>

  </div>
</div>
